import React, { useMemo } from 'react';

import SitemapLinksSection from '../sitemapLinksSection';

const MostCommonJobs = ({ mostCommonJobTitles }) => {
  const links = useMemo(() => {
    let data = [];

    mostCommonJobTitles.forEach((i) => {
      let item = {};
      item.mainTitle = i.jobTitle;
      item.mainLink = i.link;
      item.subLinks = [];

      if (i.jobsPageLink) item.subLinks.push({ title: 'Jobs', link: i.jobsPageLink });
      if (i.salaryPageLink) item.subLinks.push({ title: 'Salary', link: i.salaryPageLink });
      if (i.locationsPageLink)
        item.subLinks.push({ title: 'Locations', link: i.locationsPageLink });

      data.push(item);
    });

    return data;
  }, [mostCommonJobTitles]);

  return (
    <section className="section">
      <div className="container">
        <SitemapLinksSection
          title={<h2 className="brandonH2 sec-head pr-15">Most In Demand Jobs And Salaries</h2>}
          links={links}
        />
      </div>
    </section>
  );
};

export default MostCommonJobs;
